import { Injectable } from '@angular/core';
import { Http,RequestOptions,Headers } from '@angular/http';

/*
  Generated class for the BeetrackProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class BeetrackProvider {
  headers: Headers;
  options: RequestOptions;
  constructor(public http: Http) {
    console.log('Hello BeetrackProvider Provider');
    this.headers = new Headers();
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('X-AUTH-TOKEN', 'e9bc7e35f7e7a17bac0d2db8d67cb04d7baeebb99278a9a3ee9a4b0f1d3b0fc4');
  }

  generateRoute(data){
    console.log("!",data);

    let body = {
      data : data
    }
    this.options = new RequestOptions({ headers: this.headers });

    return this.http.post("https://admin.fitfood.cl/beetrackRoute",body,this.options)
      .toPromise()
  }


  createRoute(data){
    console.log("!",data);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('api_token', '699a0b554db52db07524bf36451967ff');

    let body = {
      data : data
    }
    this.options = new RequestOptions({ headers });

    return this.http.post("https://us-central1-yoloentrego-app.cloudfunctions.net/createDelivery",body,this.options).toPromise()
  }

}



// WEBPACK FOOTER //
// ./src/providers/beetrack/beetrack.ts